import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './features/home/home.component';
import { FaqsComponent } from './features/faqs/faqs.component';
import { ContactUsComponent } from './features/contact-us/contact-us.component';
import { DistrictLevelOfficialComponent } from './dialogs/district-level-official/district-level-official.component';
import { MatDialogModule } from '@angular/material/dialog';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchByKeywordComponent } from './features/searchforstudents/search-by-keyword/search-by-keyword.component';
import { SearchforstudentsComponent } from './features/searchforstudents/searchforstudents.component';
import {MatExpansionModule} from '@angular/material/expansion';
import { MatMenuModule} from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule} from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { ViewStudentDetailsComponent } from './features/searchforstudents/dialogs/view-student-details/view-student-details.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SearchByCampusComponent } from './features/searchforstudents/search-by-campus/search-by-campus.component';
import { AdminComponent } from './features/admin/admin.component';
import { MatInputModule } from '@angular/material/input';
import { AddUserComponent } from './features/admin/dialogs/add-user/add-user.component';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalRedirectComponent, MsalService, ProtectedResourceScopes } from '@azure/msal-angular';
import { BrowserCacheLocation, IPublicClientApplication, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { FailedComponent } from './features/failed/failed.component';
import {  MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ResendWelcomeletterComponent } from './features/admin/dialogs/resend-welcomeletter/resend-welcomeletter.component';
import { EmailValidatorDirective } from './directives/email-validator.directive';
import { UserIDValidatorDirective } from './directives/user-idvalidator.directive';
import { MatSelectModule } from '@angular/material/select';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ReportsComponent } from './features/reports/reports.component';
import { ArchivedRostersComponent } from './features/reports/archived-rosters/archived-rosters.component';
import { ReportsStartComponent } from './features/reports/reports-start/reports-start.component';


export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.msalConfig.auth.authority,
      redirectUri:  environment.msalConfig.auth.redirecturi,
      postLogoutRedirectUri:  environment.msalConfig.auth.logouturi
    }, cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    },

  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(environment.apiConfig.uri, environment.apiConfig.scopes);
  protectedResourceMap.set(environment.apiConfig.ftUri, environment.apiConfig.ftScopes);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...environment.apiConfig.scopes]
    },
   loginFailedRoute: '/failed'
  };
}
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    FaqsComponent,
    ContactUsComponent,
    DistrictLevelOfficialComponent,
    SearchByKeywordComponent,
    SearchforstudentsComponent,
    ViewStudentDetailsComponent,
    SearchByCampusComponent,
    AdminComponent,
    AddUserComponent,
    FailedComponent,
    ResendWelcomeletterComponent,
    EmailValidatorDirective,
    UserIDValidatorDirective,
    ReportsComponent,
    ArchivedRostersComponent,
    ReportsStartComponent
  ],
  imports: [
    BrowserModule,
    MatDialogModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    MatExpansionModule,
    BrowserAnimationsModule,
    MatCardModule,
    MatMenuModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    MatInputModule,
    MatAutocompleteModule,
    MsalModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatInputModule,
    MatSelectModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalBroadcastService,
    MsalGuard,
  ],
  bootstrap: [AppComponent,MsalRedirectComponent]
})

export class AppModule { }
